export const validateNullOrEmpty = (workOrderFields) => {
  let filteredFields = workOrderFields.filter(element => element != null && element.toString().trim() !== "");
  let content = "Unknown";
  if(filteredFields.length > 0){
    content = filteredFields.join(' ');
  }
  
  return content; 
}